import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';
import { WorkingHourProofBuilder } from '../../models/builders/working-hour-proof.builder';
import { WorkingHourProof } from '../../models/working-hour-proof';
import { getUserLogged } from '../../utils/jwt.utils';

const workingHourProofBody = (workingHourProof: WorkingHourProof) => ({
  userHash: (workingHourProof.userHash) ? workingHourProof.userHash : getUserLogged(),
  hash: workingHourProof.hash,
  day: workingHourProof.day,
  totalTime: workingHourProof.totalTime,
  proofHash: workingHourProof.proofHash
});

@Injectable()
export class WorkingHourProofApiService {

  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${environment.apiUrl}workingHourProofs`;
  }

  createWorkingHourProof(workingHourProof: WorkingHourProof) {
    return this.httpClient.post(
      this.apiUrl,
      workingHourProofBody(workingHourProof)
    ).pipe(map(WorkingHourProofBuilder.fromJson));
  }

  createWorkingHourProofValidated(workingHourProof: WorkingHourProof) {
    return this.httpClient.post(
      `${this.apiUrl}/validated`,
      workingHourProofBody(workingHourProof)
    ).pipe(map(WorkingHourProofBuilder.fromJson));
  }

  validateWorkingHourProof(workingHourProof: WorkingHourProof, validate: boolean) {
    const params = new HttpParams().append('validate', validate.toString());
    return this.httpClient.put(
      `${this.apiUrl}/${workingHourProof.hash}/validate`,
      params
    ).pipe(map(WorkingHourProofBuilder.fromJson));
  }

  updateWorkingHourProof(workingHourProof: WorkingHourProof) {
    return this.httpClient.put(
      `${this.apiUrl}/${workingHourProof.hash}`,
      workingHourProofBody(workingHourProof)
    );
  }

  updateWorkingHourProofValidated(workingHourProof: WorkingHourProof) {
    return this.httpClient.put(
      `${this.apiUrl}/${workingHourProof.hash}/validated`,
      workingHourProofBody(workingHourProof)
    );
  }

  deleteWorkingHourProof(workingHourProof: WorkingHourProof) {
    return this.httpClient.delete(`${this.apiUrl}/${workingHourProof.hash}`);
  }

  deleteWorkingHourProofValidation(workingHourProofHash: string, workingHourValidationHash: string) {
    return this.httpClient.delete(`${this.apiUrl}/${workingHourProofHash}/validation/${workingHourValidationHash}`);
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/working-hour-proof-api.service.ts